import { render } from "./DynamicFormExtend.vue?vue&type=template&id=5967aa4e&scoped=true&ts=true"
import script from "./DynamicFormExtend.vue?vue&type=script&lang=ts"
export * from "./DynamicFormExtend.vue?vue&type=script&lang=ts"

import "./DynamicFormExtend.vue?vue&type=style&index=0&id=5967aa4e&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5967aa4e"]])

export default __exports__